import { styled, TableCell, tableCellClasses, TableRow } from '@/shared/ui';

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: '22px',
  paddingBottom: 8,
  verticalAlign: 'center',
  borderBottom: `0.5px solid ${theme.palette.gx.neutral}`,
  '&:last-child': {
    border: 0,
    borderBottom: 0
  }
}));
